import {
  Card,
  CardHeader,
  Checkbox,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import {
  applyParentChildConstraintsOnArray,
  handleToggle,
  handleToggleAll,
  numberOfChecked,
} from '../utils'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import React, { useState } from 'react'

const CustomOrderableList = ({ title, items, checked, setChecked, setGroupByColumns }) => {
  const [hovered, setHovered] = useState(false)

  const handleMouseEnter = () => {
    setHovered(true)
  }

  const handleMouseLeave = () => {
    setHovered(false)
  }

  const handleGoUp = (index) => {
    if (index >= 1) {
      const curSequence = items[index].sequence
      const preSequence = items[index - 1].sequence
      const updatedSequence = items.map((it, pos) => {
        if (pos == index - 1) {
          return { ...it, sequence: curSequence }
        } else if (pos == index) {
          return { ...it, sequence: preSequence }
        } else {
          return it
        }
      })
      setGroupByColumns(
        applyParentChildConstraintsOnArray(
          updatedSequence.sort((a, b) => a.sequence - b.sequence)
        ).map((it) => it.path.split('__')[0])
      )
    }
  }

  const handleGoDown = (index) => {
    if (index < items.length - 1) {
      const curSequence = items[index].sequence
      const nextSequence = items[index + 1].sequence
      const updatedSequence = items.map((it, pos) => {
        if (pos == index) {
          return { ...it, sequence: nextSequence }
        } else if (pos == index + 1) {
          return { ...it, sequence: curSequence }
        } else {
          return it
        }
      })
      setGroupByColumns(
        applyParentChildConstraintsOnArray(
          updatedSequence.sort((a, b) => a.sequence - b.sequence)
        ).map((it) => it.path.split('__')[0])
      )
    }
  }

  return (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items, checked, setChecked)}
            checked={numberOfChecked(items, checked) === items.length && items.length !== 0}
            indeterminate={
              numberOfChecked(items, checked) !== items.length &&
              numberOfChecked(items, checked) !== 0
            }
            color="primary"
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items, checked)}/${items.length} selected`}
      />
      <Divider />
      <List
        sx={{
          width: 210,
          height: 230,
          bgcolor: 'background.paper',
          overflow: 'auto',
        }}
        dense
        component="div"
        role="list"
      >
        {items
          .sort((a, b) => a.sequence - b.sequence)
          .map((value, index) => {
            const labelId = `transfer-list-all-item-${value}-label`
            return (
              <ListItem
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                key={value.path}
                role="listitem"
              >
                <ListItemIcon>
                  <Checkbox
                    checked={checked.indexOf(value) !== -1}
                    color="primary"
                    tabIndex={-1}
                    disableRipple
                    inputProps={{
                      'aria-labelledby': labelId,
                    }}
                    onClick={handleToggle(value, checked, setChecked)}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={value.name} />
                {hovered && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'absolute',
                      top: 8,
                      right: 0,
                      background: 'white',
                    }}
                  >
                    <IconButton onClick={() => handleGoUp(index)} size="small">
                      <KeyboardArrowUpIcon />
                    </IconButton>
                    <IconButton onClick={() => handleGoDown(index)} size="small">
                      <KeyboardArrowDownIcon />
                    </IconButton>
                  </div>
                )}
              </ListItem>
            )
          })}
      </List>
    </Card>
  )
}

export default CustomOrderableList
